import { styled } from "@styles";

export const Wrapper = styled.div``;

export const FilterWrapper = styled.div``;

export const FilterHeader = styled.div`
  border-bottom: 1px solid #d3d1d0;
  cursor: pointer;
  display: grid;
  grid-template-columns: calc(100% - 20px) 20px;
  margin-bottom: .5rem;
  padding-bottom: .5rem;
`;

export const FilterHeaderTitle = styled.h3`
  font-weight: 700;
  padding-right: .5rem;
  margin: 0;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const FilterContent = styled.div`
  transition: all .2s ease-in-out;
  overflow: hidden;
  max-height: 500px;
`;

export const FilterRangeSpan = styled.span`
  width: 20%;
  text-align: center;
  display: inline-block;
`;

export const FilterContentFormWrapper = styled.div`
  padding: 1rem 0;
`;

export const FilterButton = styled.h3`
  text-align: center;
`;